export default "/images/vendor/@coreui/icons/svg/flag/cif-sy.svg?6d7ec0436df90911d2a5a473115cdda2";